import React, { useState, useEffect } from "react";

import ChatBox from "./ChatMessageBox";
import ChatMessageInput from "./ChatMessageInput";
import ReportModalContainer from "./ReportModalContainer";
import ChatImgModal from "./ChatImgModal";
import BackBar from "../../common/nav/BackBar";
import ISonicMessage from "../../common/classes/SonicMessage";

type Props = {
  userId: string;
  pastMessages: Array<ISonicMessage>;
  hasNext: boolean;
  clientEvent: string;
  sendMessageHandler: (msg: string, img?: File) => void;
  handleLoad: (page: number) => Promise<void>;
  readMessage: (
    messageIds: Array<string>,
    messages: Array<ISonicMessage>
  ) => void;
  setClientEvent: (value: string) => void;
  chatPartners: Array<{ id: string; name: string; chat_denial: boolean }>;
  sendDisabled: boolean;
};

const ChatPage: React.FC<Props> = ({
  userId,
  pastMessages,
  hasNext,
  clientEvent,
  sendMessageHandler,
  handleLoad,
  readMessage,
  setClientEvent,
  chatPartners,
  sendDisabled,
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [isZoom, setIsZoom] = useState<boolean>(false);
  const [img, setImg] = useState<string>("");

  const handleImgZoom = (src: string) => {
    setIsZoom(true);
    setImg(src);
  };

  const handleModalClose = () => {
    setIsZoom(false);
    setImg("");
  };

  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = isZoom ? "hidden" : "unset";
    }
  }, [isZoom]);

  const genChatPartnerNames = (
    chatPartners: Array<{ id: string; name: string }>
  ) => {
    const names: Array<string> = [];
    chatPartners.forEach((partner: { id: string; name: string }) =>
      names.push(partner.name)
    );
    return names.join("、");
  };

  return (
    <>
      <BackBar
        title={
          chatPartners.length > 0
            ? genChatPartnerNames(chatPartners)
            : "ユーザーが見つかりません"
        }
        handleClose={() => history.back()}
        editable={true}
        reportModalHandler={() => setModalOpen(true)}
      />
      <ChatBox
        userId={userId}
        pastMessages={pastMessages}
        hasNext={hasNext}
        clientEvent={clientEvent}
        handleLoad={handleLoad}
        readMessage={readMessage}
        handleImgZoom={handleImgZoom}
        setClientEvent={setClientEvent}
      />
      <ChatMessageInput
        sendMessageHandler={sendMessageHandler}
        sendDisabled={sendDisabled}
      />
      {modalOpen ? (
        <ReportModalContainer
          chatPartners={chatPartners}
          modalHandler={() => setModalOpen(false)}
        />
      ) : null}
      {isZoom && <ChatImgModal img={img} handleModalClose={handleModalClose} />}
    </>
  );
};

export default ChatPage;
